import { FC, useEffect, useState, PropsWithChildren } from "react";
import ReactDOM from "react-dom";

type ContainerFunc = () => HTMLElement;
type Container = HTMLElement | ContainerFunc;
interface IPortal {
  container?: Container;
}

const getContainer = (container: Container) => {
  return typeof container === "function" ? container() : container;
};

export const Portal: FC<PropsWithChildren<IPortal>> = ({
  children,
  container = document.body,
}) => {
  const [mountNode, setMountNode] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setMountNode(getContainer(container));
  }, [container]);

  return mountNode ? ReactDOM.createPortal(children, mountNode) : mountNode;
};

Portal.displayName = "Portal";
